import { useRef, useState, useEffect } from 'react';
import type { WorkflowNode } from '../../../../types/workflow';

export function useExplorationBanner({
  nodes,
  isRunning,
}: {
  nodes: WorkflowNode[];
  isRunning: boolean;
}): { isVisible: boolean; dismiss: () => void } {
  const [isVisible, setIsVisible] = useState(false);
  const dismissedRef = useRef(false);
  const prevRunningRef = useRef(false);

  useEffect(() => {
    // Detect transition to running
    if (isRunning && !prevRunningRef.current) {
      dismissedRef.current = false;

      const actionNodes = nodes.filter((n) => n.type !== 'login');
      const uncachedCount = actionNodes.filter((n) => !n.data.hasCachedReplay).length;

      if (uncachedCount > 4) {
        setIsVisible(true);
      }
    }

    // Auto-hide when run ends
    if (!isRunning && prevRunningRef.current) {
      setIsVisible(false);
    }

    prevRunningRef.current = isRunning;
  }, [isRunning, nodes]);

  const dismiss = () => {
    dismissedRef.current = true;
    setIsVisible(false);
  };

  return { isVisible: isVisible && !dismissedRef.current, dismiss };
}
